import { render, staticRenderFns } from "./SenhaEsqueceu.vue?vue&type=template&id=9689077e&scoped=true"
import script from "./SenhaEsqueceu.vue?vue&type=script&lang=js"
export * from "./SenhaEsqueceu.vue?vue&type=script&lang=js"
import style0 from "./SenhaEsqueceu.vue?vue&type=style&index=0&id=9689077e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9689077e",
  null
  
)

export default component.exports